<template>
  <multiselect-original
    v-bind="attrsWithoutHandlers"
    :value="modelValue"
    @input="onInput"
    @select="$emit('select', $event)"
    @remove="$emit('remove', $event)"
    @search-change="$emit('search-change', $event)"
    @tag="$emit('tag', $event)"
    @open="$emit('open')"
    @close="$emit('close')"
  >
    <!-- Fix Vue 3: <template> inside slot default doesn't render, provide singleLabel explicitly -->
    <template #singleLabel="{ option }">
      <slot name="singleLabel" :option="option">
        <span>{{ resolveLabel(option) }}</span>
      </slot>
    </template>

    <!-- Forward all other slots -->
    <template v-for="(_, name) in otherSlots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}" />
    </template>
  </multiselect-original>
</template>

<script>
import MultiselectOriginal from 'vue-definition-utils/src/utils/multiselect'

export default {
  name: 'Multiselect',
  components: { MultiselectOriginal },
  inheritAttrs: false,
  props: {
    modelValue: { default: null }
  },
  emits: ['update:modelValue', 'input', 'select', 'remove', 'search-change', 'tag', 'open', 'close'],
  computed: {
    attrsWithoutHandlers () {
      const result = {}
      for (const [key, val] of Object.entries(this.$attrs)) {
        if (!key.match(/^on[A-Z]/)) {
          result[key] = val
        }
      }
      return result
    },
    otherSlots () {
      const { singleLabel, ...rest } = this.$slots
      return rest
    }
  },
  methods: {
    onInput (val) {
      this.$emit('update:modelValue', val)
      this.$emit('input', val)
    },
    resolveLabel (option) {
      // customLabel prop forwarded via $attrs (Vue 3 camelCase)
      const customLabel = this.$attrs.customLabel || this.$attrs['custom-label']
      if (customLabel && typeof customLabel === 'function') {
        return customLabel(option)
      }
      // label prop: use option[label] if object, else option directly
      const label = this.$attrs.label
      if (label && option && typeof option === 'object') {
        return option[label]
      }
      return option
    }
  }
}
</script>
